const isNull = (v) => v === null

const cutString = (string, from, to) => string.substr(from, to)

export {
    isNull,
    cutString,
}
